module.exports = __webpack_public_path__ + "static/media/loading.c79c5bf6.gif";